import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/** `eventName` matches the `type` of the actions dispatched by `Application/AuditTrail/**`. */
const AuditTrailNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="AUDIT_TRAIL_EXPORTED"
				title="Export réalisé"
				message="Le journal d'audit a été exporté."
			/>
			<ErrorNotification
				eventName="AUDIT_TRAIL_EXPORT_FAILED"
				title="Erreur"
				message="Le journal d'audit n'a pas pu être exporté."
			/>
			<ErrorNotification
				eventName="AUDIT_ENTRIES_FETCH_FAILED"
				title="Erreur"
				message="Le journal d'audit n'a pas pu être chargé."
			/>
		</React.Fragment>
	);
};

export default AuditTrailNotifications;
